export default __webpack_public_path__ + "static/media/instructions_2.a0c6f347.svg";